import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { SortableConfig } from '../../types';
import * as Styled from './styles';
import * as SX from './sx';
import type { SortableItemRowProps as Props } from './types';

export const SortableItemRow = memo(
  ({
    className,
    item,
    createDialogState,
    openingDialogState,
    columns,
  }: Props) => {
    const render = (col: SortableConfig) =>
      (col.render
        ? col.render(
            item,
            createDialogState,
            openingDialogState,
            Number(item.id)
          )
        : item[col.key as string]) ?? '-';

    return (
      <Styled.Wrapper
        className={classnames('SortableItemRow', className)}
        sx={SX.root}
      >
        {columns.map((col) => (
          <Stack key={String(col.key)} sx={col.sx}>
            {render(col)}
          </Stack>
        ))}
      </Styled.Wrapper>
    );
  }
);

SortableItemRow.displayName = 'SortableItemRow';
